module.exports = __webpack_public_path__ + "static/media/gd.fe81c3d2.svg";